"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticContext = exports.GridContext = void 0;
var _context = require("@rc-component/context");
var StaticContext = exports.StaticContext = (0, _context.createContext)(null);
var GridContext = exports.GridContext = (0, _context.createContext)(null);